module.exports = __webpack_public_path__ + "static/media/75a-the-founding-of-prc-01.82a4b76b.png";